import { Link } from 'gatsby';
import * as React from 'react';

export default function LinkResolver(children, props) {
  const { story, target, title } = props;
  let { href } = props;

  if (story && story.full_slug) {
    href = story.full_slug;
  }

  if (!href) {
    return children;
  }

  let linkTarget = target;

  if ((href.startsWith('https://') || href.startsWith('wwww')) && !href.includes('latori.com')) {
    linkTarget = '_blank';
  }

  const isExternal = linkTarget === '_blank';
  const Tag = isExternal ? 'a' : Link;
  let _href = `/${href.replace('-old', '')}`;
  if (href[0] === '/' || href.includes('http') || href.includes(':')) {
    _href = href;
  }

  return (
    <Tag
      href={_href}
      to={_href}
      title={title || undefined}
      target={linkTarget}
      rel={isExternal ? 'noopener noreferrer' : 'index follow'}
    >
      {children}
    </Tag>
  );
}
